<template>
    <base-modal ref="baseModal" :ok-only="true" @resetform="resetForm()" :load-data="loadData" :send="send" :valid-form="true">
        <template v-slot:header>
            <h3>{{$t('agent_report_title')}}</h3>
        </template>

        <ul v-if="reportData">
            <li><b>{{$t('answer_incomingCalls')}}:</b> {{reportData.answeredIncoming}}</li>
            <li><b>{{$t('answer_outgoingCalls')}}:</b> {{reportData.outgoingCount}}</li>
            <li><b>{{$t('total_break_time')}}:</b> {{totalBreakTime}}</li>
        </ul>
    </base-modal>

</template>

<script>
import BaseModal from "./BaseModal";
import {AgentService} from "../services/agent-service";

export default {
	props: {agentService: AgentService},
	data: () => ({reportData: null, isLoading: false, isError: false}),
	components: {BaseModal},
	methods: {
		async open() {
			this.$refs.baseModal.open();
		},
		async loadData() {
			this.reportData = await this.agentService.getReport();
		},
		resetForm() {
			this.reportData = null;
		},
		convertSecondsToHour(seconds) {
			let dt = new Date(1970, 0, 1);
			dt.setSeconds(seconds);
			const format = (number) => ((number >= 10 ? "" : "0") + number.toString());
			return [dt.getHours(), dt.getMinutes(), dt.getSeconds()].map(format).join(":");
		},
		send() {
			return Promise.resolve("ok");
		}
	},
	computed: {
		totalBreakTime() {
			if (!this.reportData) {
				return null;
			}
			return this.convertSecondsToHour(this.reportData.totalBreak);
		}
	}
};
</script>

<style lang="scss" scoped>
ul {
    margin:20%;
    li {
        padding: 5px;
    }
}
</style>